package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_06_09_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-06-09")
@Composable
public fun Log_2023_06_09(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Carnage Crew",
        ogTitle = "The Carnage Crew",
        date = LocalDate(2_023, 6, 9),
        ogDescription = "The heroes are carpet-bombed by the mysterious Carnage Crew, leading to a pointer toward their location.",
        ogImage = "ai/2023-06-09.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-29", dateString = "Newgrowth 29")
        Log_2023_06_09_Day_1()
    }
}
